import { apiJson } from '@/api/client'
import type {
  AccessRequest,
  CreateAccessRequestPayload,
  DecideAccessRequestPayload,
} from './types'

export async function listMyAccessRequests(): Promise<AccessRequest[]> {
  const res = await apiJson<{ items: AccessRequest[] }>('/access-requests/mine')
  return res.items ?? []
}

export async function listPendingAccessRequests(
  status: string[] = ['pending'],
): Promise<AccessRequest[]> {
  const sp = new URLSearchParams()
  for (const s of status) sp.append('status', s)
  const res = await apiJson<{ items: AccessRequest[] }>(
    `/access-requests?${sp.toString()}`,
  )
  return res.items ?? []
}

export function getAccessRequest(id: string): Promise<AccessRequest> {
  return apiJson<AccessRequest>(`/access-requests/${id}`)
}

export function createAccessRequest(
  payload: CreateAccessRequestPayload,
): Promise<AccessRequest> {
  return apiJson<AccessRequest>('/access-requests', {
    method: 'POST',
    body: payload,
  })
}

export function approveAccessRequest(
  id: string,
  payload: DecideAccessRequestPayload = {},
): Promise<AccessRequest> {
  return apiJson<AccessRequest>(`/access-requests/${id}/approve`, {
    method: 'POST',
    body: payload,
  })
}

export function denyAccessRequest(
  id: string,
  payload: DecideAccessRequestPayload,
): Promise<AccessRequest> {
  return apiJson<AccessRequest>(`/access-requests/${id}/deny`, {
    method: 'POST',
    body: payload,
  })
}
